import { store } from '../state.js';
import { showToast } from '../toast.js';

const CHANNELS = [
    { id: 'telegram', label: 'Telegram' },
    { id: 'email', label: 'Почта' },
    { id: 'sms', label: 'SMS' },
    { id: 'browser', label: 'Уведомления в браузере' },
    { id: 'sound', label: 'Звук в кабинете' }
];

const CRM_LIST = [
    { id: 'amocrm', label: 'amoCRM' },
    { id: 'bitrix24', label: 'Битрикс24' },
    { id: 'retailcrm', label: 'RetailCRM' },
    { id: 'sheets', label: 'Google Таблицы' },
    { id: 'webhook', label: 'Webhook' }
];

function crmStatusLabel(status) {
    if (status === 'connected') return 'Подключено';
    if (status === 'configuring') return 'Настраивается';
    return 'Подключить';
}

export function renderNotifications(container) {
    const state = store.get();

    container.innerHTML = `
        <div class="ov-grid">
            <div class="ov-card">
                <div class="ov-card__title">Каналы уведомлений</div>
                <div class="notif-channels">
                    ${CHANNELS.map(ch => `
                        <label class="notif-channel">
                            <span>${ch.label}</span>
                            <span class="dir-row__main-switch">
                                <input type="checkbox" data-channel="${ch.id}" ${state.settings.channels[ch.id] ? 'checked' : ''}>
                                <span></span>
                            </span>
                        </label>
                    `).join('')}
                </div>
            </div>

            <div class="ov-card">
                <div class="ov-card__title">Превью в Telegram</div>
                <div class="notif-preview">
                    <div class="notif-preview__head">Kefir · Лидогенерация</div>
                    <div class="notif-preview__body">
                        🆕 Новая заявка №10541<br>
                        Стиральные машины · Москва, САО<br>
                        Ольга, +7 00•• ••-77-22
                    </div>
                    <div class="notif-preview__actions">
                        <button type="button">Взять в работу</button>
                        <button type="button">Открыть</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="ov-card">
            <div class="ov-card__title">Интеграции</div>
            <div class="notif-crm">
                ${CRM_LIST.map(crm => `
                    <div class="notif-crm__row">
                        <span>${crm.label}</span>
                        <button type="button" class="notif-crm__btn notif-crm__btn--${state.settings.crm[crm.id]}" data-crm="${crm.id}" ${state.settings.crm[crm.id] !== 'none' ? 'disabled' : ''}>${crmStatusLabel(state.settings.crm[crm.id])}</button>
                    </div>
                `).join('')}
            </div>
        </div>
    `;

    container.querySelectorAll('[data-channel]').forEach(input => {
        input.addEventListener('change', () => {
            store.update(s => { s.settings.channels[input.dataset.channel] = input.checked; });
            if (input.dataset.channel === 'browser' && input.checked && 'Notification' in window) {
                Notification.requestPermission();
            }
        });
    });

    container.querySelectorAll('[data-crm]').forEach(btn => {
        btn.addEventListener('click', () => {
            store.update(s => { s.settings.crm[btn.dataset.crm] = 'configuring'; });
            showToast('Интеграция настраивается, мы свяжемся с вами');
            renderNotifications(container);
        });
    });
}
